export default {"src":"/_next/static/media/0x24A6A37576377F63f194Caa5F518a60f45b42921.d1acc3d4.svg","height":115,"width":115,"blurWidth":0,"blurHeight":0};